<template>
    <Accordion>
        <template v-slot:title>{{ translate("notification_center.show_notification_criteria") }}</template>
        <template v-slot:content>
            <div class="has-text-left">
                <div v-if="receiversDescriptionKey" class="mb-1">
                    <span class="is-description">{{ translate("notification_center.criteria.receivers") }}</span>
                    {{ translate(receiversDescriptionKey) }}
                </div>
                <div v-else class="mb-1">
                    <span class="is-description">{{ translate("notification_center.payments_filter") }}:</span>

                    <PaymentStatusTag :payment-status="notificationOrder.criteria.paymentStatus" />
                </div>
                <div>
                    <span class="is-description">{{ translate("notification_center.source_events") }}</span>
                    <a
                        v-for="sourceEvent in notificationOrder.sourceEvents"
                        class="mr-1"
                        target="_blank"
                        :key="sourceEvent.id"
                        :href="publicEventPages(sourceEvent.id, sourceEvent.urlSlug).mainEventPageUrl()"
                    >
                        {{ sourceEvent.name }}
                    </a>
                </div>
            </div>
        </template>
    </Accordion>
</template>

<script>
    import Accordion from "../../Common/Accordion.vue";
    import translatorMixin from "../../Common/translatorMixin";
    import urlsMixin from "../../Urls/urlsMixin";
    import PaymentStatusTag from "../Common/PaymentStatusTag.vue";

    const RECEIVERS_DESCRIPTION_KEYS = {
        singleCompetitorCategories: "notification_center.criteria.single_competitor_categories",
    };

    export default {
        name: "criteria-summary",
        components: { PaymentStatusTag, Accordion },
        mixins: [translatorMixin, urlsMixin],
        props: ["notificationOrder"],
        computed: {
            /**
             * Orders of predefined notifications are sent to an explicit set of users, so the payments filter of the
             * criteria says nothing about them. Their receivers are described by the template instead.
             */
            receiversDescriptionKey() {
                return RECEIVERS_DESCRIPTION_KEYS[this.notificationOrder.emailTemplate] ?? null;
            },
        },
    };
</script>

<style scoped></style>
